import { render, staticRenderFns } from "./GamesListView.vue?vue&type=template&id=2dcc6ca9&"
import script from "./GamesListView.vue?vue&type=script&lang=js&"
export * from "./GamesListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports